import { createTheme, Typography } from '@mui/material';

export default function HorarioAtendimento({ isWhiteText }) {
  const theme = createTheme();

  const colorText = isWhiteText
    ? theme.palette.common.white
    : theme.palette.text.secondary;

  const shadowText = isWhiteText ? '1px 1px rgba(0, 0, 0, 0.4)' : '0px';

  return (
    <>
      <Typography
        variant="h5"
        color={colorText}
        sx={{
          textAlign: 'center',
          textShadow: { shadowText },
        }}
      >
        Horário de atendimento
      </Typography>
      <Typography
        variant="body1"
        color={colorText}
        sx={{
          textAlign: 'center',
          m: 1,
          textShadow: { shadowText },
        }}
      >
        Segunda a Sexta
        <br />
        08:00 às 11:50 e 13:30 às 17:50
      </Typography>
    </>
  );
}
